import React, { Component } from 'react';
import {Paper, Grid, Typography, Button} from '@material-ui/core';
import * as Gserv from '../services/GatewayService';
import DatasheetView from './DatasheetView';
import InputField from './InputField';
import DropDown from './DropDown';
// import Toggle from './Toggle';

export default class Competencies extends Component {

    constructor(props) {
        super(props);
        this.reset_state = {
            assessments_view: false,
            empl_num_error: null,
            empl_num_input: '',
            name_error: null,
            name_input: '',
            can_submit: true,
            writing: false,
            deleting: false,
            error: false,
            error_message: '',
            querying: true,
            comps_array: [],
            show_dialogue: false,
            form_view: false,
            form_data: {},
            current_record: {},
            primary_button_enabled: false,
            primary_button_text: 'Create Competency'
        }
        this.state = {  //Note: designations not reset
            assessments_view: false,
            empl_num_error: null,
            empl_num_input: '',
            name_error: null,
            name_input: '',
            can_submit: true,
            writing: false,
            deleting: false,
            divisions: [],
            areas: [],
            error: false,
            error_message: '',
            querying: true,
            comps_array: [],
            show_dialogue: false,
            form_view: false,
            form_data: {},
            current_record: {},
            primary_button_enabled: false,
            primary_button_text: 'Create Competency'            
        };
        this.datasheetFieldSpecs = [
            { field: 'division', headerName: 'Division', width: 115},
            { field: 'area', headerName: 'Area', width: 145},
            { field: 'sort_order', headerName: '#', width: 65, headerAlign:'center', align: 'center'},
            { field: 'id', headerName: 'Code', width: 80, sortable: false},
            { field: 'competency', headerName: 'Competency Narration', width: 640, sortable:false},
        ]

        this.input_fieldSpecs = [

            {field: "division", headerName: "Division", f_inputType:'dropdown', f_show:true, f_required:true},

            {field: "area", headerName: "Area", f_inputType:'dropdown', f_show:true, f_required:true},

            {field: "competency_id", headerName: "Code", f_inputType:'text', f_show:true, f_required:true,  f_minLength: 2, f_maxLength: 5},
 
            {field: "competency", headerName: "Competency Narration", f_inputType:'text', f_show:true, f_required:false,  f_minLength: 5, f_maxLength: 200},
            
            {field: "sort_order", headerName: "Sort Order", f_inputType:'number', f_show:true, f_required:false,  f_maxLength: 3},
    
        ]
    }

    componentDidMount = () => {

        //async get divisions... - once off
        if (this.state.divisions.length===0){  
            Gserv.sendCommand('query_divisions',this.props.gwt)
            .then(divisions => {
                // console.log('divisions :>> ', divisions);
                if (divisions.error){
                    console.log('error on return from Gserv (query_divisions) :>> ', divisions);
                    this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
                } else if (divisions.Result!=="Success"&&divisions.statusCode!==204){
                    console.log('error on return from Gserv (query_divisions) :>> ', divisions);
                    this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
                } else {

                    this.setState({divisions: divisions.Records});
                }
            }); 
        }
 
        //async get areas... - once off
        if (this.state.areas.length===0){  
            Gserv.sendCommand('query_areas',this.props.gwt)
            .then(areas => {
                // console.log('areas :>> ', areas);
                if (areas.error){
                    console.log('error on return from Gserv (query_areas) :>> ', areas);
                    this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
                } else if (areas.Result!=="Success"&&areas.statusCode!==204){
                    console.log('error on return from Gserv (query_areas) :>> ', areas);
                    this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
                } else {
                    this.setState({areas: areas.Records});
                }
            }); 
        }

        Gserv.sendCommand('query_competency_template',this.props.gwt)
        .then(reply=>{
            // console.log('query_competency_template reply :>> ', reply);
            if (reply.error){
                console.log('error on return from Gserv (query_competency_template) :>> ', reply);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
            } else if (reply.Result!=="Success"&&reply.statusCode!==204){
                console.log('error on return from Gserv (query_competency_template) :>> ', reply);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
            } else {
                
                //clean formats for display
                // if (reply.Records){
                // let cycle_array = reply.Records;
                //     let open_date = null;
                //     let deadline_date = null;
                //     let employed_from = null;
                //     for (var i=0;i<cycle_array.length;i++){
                //         open_date = new Date(cycle_array[i].open_date);
                //         deadline_date = new Date(cycle_array[i].deadline_date);
                //         employed_from = new Date(cycle_array[i].employed_from);
                //         cycle_array[i].open_date = open_date.getFullYear() + "-" +  Calc.twoDigit((open_date.getMonth()+1)) + "-" + Calc.twoDigit(open_date.getDate());;
                //         cycle_array[i].deadline_date = deadline_date.getFullYear() + "-" +  Calc.twoDigit((deadline_date.getMonth()+1)) + "-" + Calc.twoDigit(deadline_date.getDate());;
                //         cycle_array[i].employed_from = employed_from.getFullYear() + "-" +  Calc.twoDigit((employed_from.getMonth()+1)) + "-" + Calc.twoDigit(employed_from.getDate());
                //         cycle_array[i].closed = cycle_array[i].closed? "YES" : "";
                //         cycle_array[i].archived = cycle_array[i].archived? "YES" : "";
                //     }
                // }
                this.setState({querying:false, comps_array:reply.Records?reply.Records : []});

            }
        });
    };

    handleChildStateUpdate = (new_state) => {
        this.setState(new_state);
    }

    editAssessments = (parms) => {
        // console.log('edit assessments with parms :>> ', parms);
        this.setState({current_record:parms.row,assessments_view:true});
    }

    processForm = (e) => {
        e.preventDefault();
        // console.log('this.state.form_data :>> ', this.state.form_data);
        this.setState({writing:true, primary_button_enabled:false});
        //set state updating here...
        
        if (this.state.current_record.id){
            //this is an update

            Gserv.sendCommand('update_competency_template',this.props.gwt,{
                form_data : this.state.form_data,
                id : this.state.current_record.id
            })
            .then(reply => {
                // console.log('update reply :>> ', reply);
                if (reply.error){
                    console.log('error on return from Gserv (update_competency_template) :>> ', reply);
                    this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
                } else if (reply.statusCode===409) {
                    console.log('error on return from Gserv (update_competency_template) :>> ', reply);
                    this.setState({error:true,error_message:"A cycle with this code or name already exists.",querying:false});
                } else if (reply.Result!=="Success") {
                    console.log('error on return from Gserv (update_competency_template) :>> ', reply);
                    this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
                } else {
                    this.setState(this.reset_state);
                    this.componentDidMount();
                }
            });           

        } else {
            //this is a create
            Gserv.sendCommand('create_competency_template',this.props.gwt,{
                form_data : this.state.form_data
            })
            .then(reply => {
                // console.log('create reply :>> ', reply);
                if (reply.error){
                    console.log('error on return from Gserv (create_competency_template) :>> ', reply);
                    this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
                } else if (reply.statusCode===409){
                    console.log('error on return from Gserv (create_competency_template) :>> ', reply);
                    this.setState({error:true,error_message:"A cycle with this code or name already exists.",querying:false});
                } else if (reply.Result!=="Success"){
                    console.log('error on return from Gserv (create_competency_template) :>> ', reply);
                    this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
                } else {
                    this.setState(this.reset_state);
                    this.componentDidMount();
                }
            });
        }
    }

    handleFieldUpdate = (fieldObj) => {
        // console.log('called field update...');
        // console.log('child field update:',fieldObj);
        // console.log(this.state.current_record);
        // eslint-disable-next-line eqeqeq
        if (fieldObj.value==''){fieldObj.value=null}
        let myFormData = this.state.form_data;
        myFormData[fieldObj.field] = fieldObj.value;
        this.setState({form_data:myFormData});
        // console.log('current_record value : ',this.state.current_record[fieldObj.field]);
        // console.log('New value : ', fieldObj.value);
        // eslint-disable-next-line eqeqeq
        if(this.state.current_record[fieldObj.field]!=fieldObj.value){
            const truthyCurrentRec = this.state.current_record[fieldObj.field]? true : false;
            const truthyFieldObj = fieldObj.value ? true : false;
            //exclude nulls vs '' vs false etc.
            if (truthyCurrentRec||truthyFieldObj){
                // console.log('found update...');
                this.setState({primary_button_enabled:true});
            }
        } 
    }

    handleUpdate = (record) => {
        // console.log('record for update :>> ', record);
        // this.setState({show_dialogue:true});
        //Hide just while testing modal...
        this.setState({current_record:record.row,form_view:true,primary_button_enabled:false,primary_button_text:'Update Competency'});
    }

    handleDelete = (record) => {
        // console.log('record for delete :>> ', record);

        // this.setState({show_dialogue:true});
        //Hide just while testing modal...
        this.setState({deleting:true,querying:true});
        Gserv.sendCommand('delete_competency_template',this.props.gwt,{
            competency_id: record.id
        })
        .then(reply => {
            // console.log('delete reply :>> ', reply);
            if (reply.error){
                console.log('error on return from Gserv (delete_competency_template) :>> ', reply);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
            } else if (reply.Result!=="Success"){
                console.log('error on return from Gserv (delete_competency_template) :>> ', reply);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
            } else {
                this.setState(this.reset_state);
                this.componentDidMount();
            }
        });

    }
    
    resetMe = () => {
        this.setState(this.reset_state);
        this.componentDidMount();
    }

    render() {
        return (
            <Grid
                container
                direction='column'
                justifyContent='center'
                alignContent='center'
                // style={{backgroundColor:'yellow'}}
            >
                {!this.state.assessments_view&&
                <Grid item>
                <Paper
                    elevation={3}
                    style={{width:1200}}
                >
                   <Typography
                    color='primary'
                    style={{paddingTop:15}}
                   >
                       Competencies
                   </Typography>
                   <Grid
                    container
                    direction='row'
                    justifyContent='space-evenly'
                    alignContent='center'
                    style={{padding:15}}
                   >
                    {!this.state.form_view&&   
                    <Button
                        variant='contained'
                        color='primary'
                        type='submit'
                        onClick={()=>this.setState({form_view:true,primary_button_text:'Create Competency',current_record:{}})}
                        disabled={this.state.form_view}
                    >
                        Create
                    </Button>}
                   </Grid>
                </Paper>
                </Grid>}

                <Grid item>
                    <Typography color='secondary' style={{Width:1155,maxWidth:1155, textAlign:'center'}}>{this.state.error_message}</Typography>
                    {this.state.error&&<Button color='primary' variant='outlined' onClick={this.resetMe}>Reset</Button>}
                </Grid>

                {/* {this.state.querying&&
                <Grid item>
                    <br/>
                    <Settings className='icn-spinner' /> Querying...
                </Grid>} */}

                {/* Datagrid goes here */}
                {!this.state.form_view&&!this.state.assessments_view&&
                <DatasheetView 
                    dataset={this.state.comps_array}
                    fieldspecs={this.datasheetFieldSpecs}
                    delete={true}
                    edit={true}
                    handleDelete={this.handleDelete}
                    handleEdit={this.handleUpdate}
                    loading={this.state.querying}
                    deleteHeaderName={'Delete'}
                    pagesize={8}
                />}

                {this.state.form_view&&!this.state.assessments_view&&
                <Paper
                    elevation={3}
                    style={{paddingBottom:'15px'}}
                >
                    <form onSubmit={this.processForm}>
                        <br/>
                        <Grid 
                            container 
                            direction='column'
                            alignItems='baseline'
                            justifyContent='center'
                            spacing={1}
                            style={{width:'100%', padding:'20px'}}
                        >

                            <DropDown fieldMap={this.input_fieldSpecs[0]} setField={this.handleFieldUpdate} editRecord={this.state.current_record} listArray={this.state.divisions} disabled={this.state.writing}/>

                            <DropDown fieldMap={this.input_fieldSpecs[1]} setField={this.handleFieldUpdate} editRecord={this.state.current_record} listArray={this.state.areas} disabled={this.state.writing}/>

                            <div style={{width:'10%'}}>
                                <InputField fieldMap={this.input_fieldSpecs[2]} setField={this.handleFieldUpdate} editRecord={this.state.current_record} disabled={this.state.writing}/>
                            </div>

                            <div style={{width:'100%'}}>
                                <InputField fieldMap={this.input_fieldSpecs[3]} setField={this.handleFieldUpdate} editRecord={this.state.current_record} disabled={this.state.writing}/>
                            </div>
                           
                            <div style={{width:'10%'}}>
                                <InputField fieldMap={this.input_fieldSpecs[4]} setField={this.handleFieldUpdate} editRecord={this.state.current_record} disabled={this.state.writing}/>
                            </div>

                            {/* Note: Have disabled archive function for intervention templates for now. To enable, uncomment below. Only allow archiving toggle when editing (not creating) a record */}
                            {/* {Object.keys(this.state.current_record).length!==0&&
                            <div style={{paddingTop:'10px'}}>
                                <Toggle fieldMap={this.input_fieldSpecs[3]} setField={this.handleFieldUpdate} editRecord={this.state.current_record} disabled={this.state.writing}/>
                            </div>}  */}

                        </Grid>
                        <Button 
                            color='primary'
                            variant='outlined'
                            disabled={!this.state.primary_button_enabled}
                            type='submit'
                            style={{marginTop:'20px'}}
                        >
                            {this.state.primary_button_text}
                        </Button>
                        <Button 
                            type='button'
                            variant='outlined'
                            disabled={this.state.writing}
                            onClick={()=>this.setState({form_view:false})}
                            style={{marginTop:'20px'}}
                        >
                            Cancel
                        </Button>
                    </form>
                </Paper>}

            </Grid>
        );
    }
    
}